import useGetMemberCompany from "#/components/company/hooks/useGetMemberCompany"
import { useContentfulEntry } from "#/lib/contentful/hooks/useContentfulEntry"
import { StaticAssetID } from "#/lib/contentful/contentfulClient"
import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { TypeCalendlyLink } from "#/types/contentful"

/*
 * If the parentCompany is "Solution Consulting (SC) / Sales Demo Accounts" (parentCompanyId = 663) for sales demo,
 * replace all CalendlyLinks with a fake CalendlyLink with abundant availability.
 * See https://carrotfertility.atlassian.net/browse/OP-2576.
 */

const RESOLVED_CALENDLY_LINK_QUERY_KEY = "resolvedCalendlyLink"

export const useResolvedCalendlyLink = (
  calendlyLink: TypeCalendlyLink<"WITHOUT_UNRESOLVABLE_LINKS", string>
): UseQueryResult<TypeCalendlyLink<"WITHOUT_UNRESOLVABLE_LINKS", string>> => {
  const memberCompany = useGetMemberCompany()
  const salesDemoCalendlyLink = useContentfulEntry(StaticAssetID.TALK_TO_CARROT_SALES_DEMO_CALENDLY_LINK)

  return useQuery<TypeCalendlyLink<"WITHOUT_UNRESOLVABLE_LINKS", string>, unknown>(
    [
      RESOLVED_CALENDLY_LINK_QUERY_KEY,
      calendlyLink?.sys?.id,
      memberCompany.data?.parentCompanyId,
      salesDemoCalendlyLink.data?.sys.id
    ],
    () =>
      memberCompany.data?.parentCompanyId === 663
        ? (salesDemoCalendlyLink.data as TypeCalendlyLink<"WITHOUT_UNRESOLVABLE_LINKS", string>)
        : calendlyLink,
    {
      enabled: !!memberCompany.data && !!salesDemoCalendlyLink.data && !!calendlyLink
    }
  )
}
